import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoyaltyImportGiftService } from 'app/services/loyalty/loyalty-import-gift.service';
import { MessageService, SelectItem } from 'primeng/api';
import { KontableComponent } from "../../../modules/UIKit/components/kontable/kontable.component";
import * as moment from 'moment';
import { ImportGiftRowsService } from 'app/services/loyalty/import-gift-rows.service';

@Component({
  selector: 'app-loyalty-import-gift',
  templateUrl: './loyalty-import-gift.component.html',
  styleUrls: ['./loyalty-import-gift.component.css']
})
export class LoyaltyImportGiftComponent implements OnInit {

  @ViewChild('importGiftTable') importTable: KontableComponent;

  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  popUp: boolean = false;
  record: any;
  optionError: SelectItem[] = [];

  constructor(
    public importService: LoyaltyImportGiftService,
    private router: Router,
    private translate: TranslateService,
    private message: MessageService,
    public calendarTranslateService: CalendarTranslateService,
    private importGiftRowsService: ImportGiftRowsService
  ) { }

  ngOnInit() {

    this.translate.get([
      'reservations.importFailed',
      'reservations.importSuccessful',
      'reservations.loadingImport',
      'reservations.missingImages'
    ]).subscribe((res) => {

      this.optionError.push({ label: res['reservations.importSuccessful'], value: '0' });
      this.optionError.push({label: res['reservations.loadingImport'], value: '1'});
      this.optionError.push({ label: res['reservations.importFailed'], value: '2' });
      this.optionError.push({label: res['reservations.missingImages'], value: '3'});
    });
  
  }

  addGift(){
    this.router.navigate(['loyalty/import-gift/detail']);
  }

  openPopUp($event){
    this.record = $event;
    this.popUp = true;
  }

  closePopUp(){
    this.popUp = false;
  }

  deleteImport(id){
    this.importService.deleteImport(id).subscribe(
      ()=> {
        this.message.add({severity: 'success', summary: 'Success', detail: 'Record Deleted'})
        this.importTable.refresh();
    }
    );
  }

  openImportGiftRowsDetail(row){
    this.importGiftRowsService.importHeadId = row.id;
    this.router.navigate([`loyalty/import-gift-rows/detail`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-import-gift/loyalty-import-gift.component.ts